import { Button } from "@remo-co/ui-core/src/components/Button";
import { ComponentProps, ReactElement } from "react";
import classNames from "classnames";
import { useStyles } from "./AuthButton.styles";

const AuthButton = ({
  children,
  className,
  variant = "secondary",
  ...rest
}: ComponentProps<typeof Button>): ReactElement => {
  const classes = useStyles();

  return (
    <Button
      className={classNames(classes.button, className)}
      variant={variant}
      startAdornmentClassName={classes.authButtonIcon}
      contentWrapperClassName={classes.contentWrapper}
      color="blue"
      size="lg"
      fullWidth
      {...rest}
    >
      {children}
    </Button>
  );
};

export default AuthButton;
